export type PostLoginTarget =
  | { type: 'external'; url: string }
  | { type: 'route'; path: string }

const HAS_SCHEME_RE = /^[a-z][a-z\d+\-.]*:\/\//i

const toBaseUrl = (baseDomain: string): URL | null => {
  const normalized = baseDomain.trim()
  if (!normalized) {
    return null
  }

  const withScheme = HAS_SCHEME_RE.test(normalized)
    ? normalized
    : `https://${normalized}`

  try {
    return new URL(withScheme)
  } catch {
    return null
  }
}

export const buildOrganizationUrl = (
  organizationDomain: string,
  baseDomain = import.meta.env.VITE_APP_DOMAIN_URL as string | undefined
): string | null => {
  const normalizedDomain = organizationDomain.trim()
  if (!normalizedDomain || !baseDomain) {
    return null
  }

  const baseUrl = toBaseUrl(baseDomain)
  if (!baseUrl?.hostname) {
    return null
  }

  const port = baseUrl.port ? `:${baseUrl.port}` : ''

  return `${baseUrl.protocol}//${normalizedDomain}.${baseUrl.hostname}${port}`
}

export const getPostLoginTarget = (): PostLoginTarget => {
  return { type: 'route', path: '/' }
}
